import { Accordion, AccordionDetails, AccordionSummary, Grid, Hidden } from '@mui/material';
import ExpandMoreIcon from '@mui/material/Icon';
import { Field } from 'formik';
import React from 'react';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { PersonSearchProps } from '../../models/arc-epi-props';
import { SearchPerson } from './person-search-model';

interface Props {
    person: SearchPerson;
    settings: PersonSearchProps,
    groupName: string,
}
export function PersonSearchItemView(props: Props) {
    const { person, groupName } = props;
    const buttonClasses = buttonStyles();
    function AddressView() {
        if (!person?.mailing_address?.city &&
            !person?.mailing_address?.state &&
            !person?.mailing_address?.postal_code &&
            !person?.mailing_address?.country) {
            return <p><em>{props.settings?.notProvidedMessage}</em></p>;
        }

        return (
            <>
                <p>{person?.mailing_address?.masked_address1}</p>
                <p>{person?.mailing_address?.masked_address2}</p>
                <p>{person?.mailing_address?.city}, {person?.mailing_address?.state}, {person?.mailing_address?.postal_code}</p>
                <p>{person?.mailing_address?.country}</p>
            </>
        );
    }

    function ExpandView() {
        return (
            <>
                <ExpandMoreIcon />
            </>
        );
    }

    function ValidatedTextValue(value: string) {
        return value || <em><span className='not-provided-text'>{props.settings?.notProvidedMessage}</span></em>;
    }


    return (
        <Accordion className='employee-search-item-accordion'>
            <AccordionSummary className='employee-search-item-accordion-summary'
                expandIcon={<ExpandView />}
                aria-controls={`content-${person?.id}`}
                id={`header-${person?.id}`}
            >
                <div className='employee-search-table-row'>
                    <div className='employee-search-table-row-cell'>
                        <Hidden smUp>
                            <p className='input-label'>{props.settings?.nameLabel}</p>
                        </Hidden>
                        <div className='employee-search-table-radio'>
                            <Field type="radio" name={groupName} value={person?.guid} />
                            
                            <span>
                                {person?.clergy &&
                                    <svg className='clergy-icon' aria-hidden='true' focusable='false'>
                                        <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#clergy-icon' />
                                    </svg>}
                                {`${person?.last_name}, ${person?.first_name} ${person?.middle_name}`}</span>
                        </div>
                    </div>
                    <div className='employee-search-table-row-cell'>
                        <Hidden smUp>
                            <p className='input-label'>{props.settings?.dobLabel}</p>
                        </Hidden>
                        <div>{ValidatedTextValue(person?.masked_date_of_birth)}</div>
                    </div>
                    <div className='employee-search-table-row-cell'>
                        <Hidden smUp>
                            <p className='input-label'>{props.settings?.ssnLabel}</p>
                        </Hidden>
                        <div>{ValidatedTextValue(person?.masked_ssn)}</div>
                    </div>
                    
                    <Hidden xsDown>
                    <div className='employee-search-table-row-cell'>
                        <span className={buttonClasses.linkButton}>{props.settings?.viewFullProfileLabel}</span>
                        </div>
                    </Hidden>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container className='employee-search-item-content'>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.clientNumberLabel}</p>
                        <p>{person?.masked_client_number}</p>
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.firstNameLabel}</p>
                        <p>{ValidatedTextValue(person?.first_name)}</p>
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.middleNameLabel}</p>
                        <p>{ValidatedTextValue(person?.middle_name)}</p>
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.lastNameLabel}</p>
                        <p>{ValidatedTextValue(person?.last_name)}</p>
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.designationLabel}</p>
                        <p>{ValidatedTextValue(person?.designation)}</p>
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.businessEmailLabel}</p>
                        <p>{ValidatedTextValue(person?.office_email?.email_address)}</p>
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.homePhoneLabel}</p>
                        <p>{ValidatedTextValue(person?.home_number?.phone_number_combined)}</p>
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.addressLabel}</p>
                        <AddressView />
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.ssnLabel}</p>
                        <p>{ValidatedTextValue(person?.masked_ssn)}</p>
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.dobLabel}</p>
                        <p>{ValidatedTextValue(person?.masked_date_of_birth)}</p>
                    </Grid>
                    <Grid className='employee-search-item-content-column' item xs={12} sm={4}>
                        <p className='input-label'>{props.settings?.genderLabel}</p>
                        <p>{ValidatedTextValue(person?.gender)}</p>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}